export default {
    parent: 'PublicLayout', // the layout we'll be using
    url: '/:company',
    abstract: true,
    template: '<ui-view/>',
    data: {
        canAccess: (AuthService) => {
            return !AuthService.isLoggedIn();
        }
    },
    resolve: {
        company ($state, $stateParams, CompanyResource) {
            return CompanyResource.verifySlug(null, { slug: $stateParams.company }).$promise
                .catch(() => {
                    $state.go('root');
                });
        },
        bootstrap (TranslationService, company) {
            // force company language for all non-authenticated views
            if (!company.defaultLanguage) {
                return null;
            }
            return TranslationService.changeLanguage(company.defaultLanguage.toLowerCase());
        }
    },
    controller ($rootScope, company, CompanyService) {
        $rootScope.company = company;
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/unauthorized/index.js